import { inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { MessageService } from '@letly/ui-common';
import { ToastSeverity } from '@letly/models';
import { LandlordRoleService } from './landlord-role.service';

const TOAST_TIMEOUT_MS = 4_000;

@Injectable({ providedIn: 'root' })
export class RoleSwitchNotificationService {
  private readonly router = inject(Router);
  private readonly landlordRoleService = inject(LandlordRoleService);
  private readonly messageService = inject(MessageService);

  private lastRole: boolean | undefined;

  constructor() {
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe(() => {
      const isLandlord = this.landlordRoleService.isLandlord();
      const isFirstNavigation = this.lastRole === undefined;
      const changed = this.lastRole !== isLandlord;
      this.lastRole = isLandlord;

      if (isFirstNavigation || !changed) return;

      const message = isLandlord
        ? $localize`:@@core.role-switch.toast.landlord:You’re now in landlord view`
        : $localize`:@@core.role-switch.toast.tenant:You’re now in tenant view`;

      this.messageService.showSnackbar(message, ToastSeverity.Success, true, undefined, false, TOAST_TIMEOUT_MS);
    });
  }
}
